import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DurationPickerDialogComponent} from '../../../dialogs/duration-picker-dialog/duration-picker-dialog.component';

@Component({
  selector: 'app-duration-editor',
  templateUrl: './duration-editor.component.html',
  styleUrls: ['./duration-editor.component.css']
})
export class DurationEditorComponent implements OnInit {

  @Input() readonly = false;
  @Input() label!: string;
  @Input() noValue = 'Не установлено';
  @Input() validators: any[] = [];
  @Input() value!: string | null;

  @Output() valueChangeEvent = new EventEmitter<string | null>();

  hours = 0;
  minutes = 0;

  constructor(
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    const data = this.parse(this.value);
    this.hours = data.hours;
    this.minutes = data.minutes;
  }

  onEdit(event: MouseEvent): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(DurationPickerDialogComponent, {
      data: {hours: this.hours, minutes: this.minutes},
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.hours = data.hours;
        this.minutes = data.minutes;
        const newValue = this.format(this.hours, this.minutes);
        if (this.value !== newValue) {
          this.valueChangeEvent.emit(newValue);
        }
      }
    });
  }

  format(hours: number, minutes: number): string | null {
    if (hours || minutes) {
      return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:00`;
    }
    return null;
  }

  parse(formatted: string | null): { hours: number, minutes: number } {
    if (formatted == null) {
      return {hours: 0, minutes: 0};
    }
    return {
      hours: +formatted.substring(0, 2),
      minutes: +formatted.substring(3, 5),
    };
  }

}
